var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import './OTP.scss';
import OtpInput from "react-otp-input";
export const OTP = (_a) => {
    var { id, numInputs, isDisabled, hasErrored, placeholder, isInputSecure, className = '', onChange, value, children, rtl, autoFocus } = _a, props = __rest(_a, ["id", "numInputs", "isDisabled", "hasErrored", "placeholder", "isInputSecure", "className", "onChange", "value", "children", "rtl", "autoFocus"]);
    return (_jsx("div", Object.assign({ className: 'storybook__OTPContainer' }, { children: _jsx("div", Object.assign({ className: `storybook_OTP_${rtl ? 'right' : 'left'}` }, { children: _jsx(OtpInput, { className: `otp-input ${className}`, value: value, children: children, placeholder: placeholder, onChange: onChange, numInputs: numInputs, separator: _jsx("span", { children: "\u00A0\u00A0\u00A0" }, void 0), inputStyle: {
                    borderWidth: "0px",
                    borderRadius: "8px",
                    backgroundColor: "#F2F4F8"
                }, shouldAutoFocus: autoFocus, isInputNum: true, isDisabled: isDisabled, hasErrored: hasErrored, isInputSecure: isInputSecure, errorStyle: {
                    width: "50px",
                    height: "80px",
                    borderWidth: "0px",
                    color: "#CF0048",
                    fontWeight: "bold"
                } }, void 0) }), void 0) }), void 0));
};
